import { EPData } from '@rsos/assets/icons';
import { COMMUNICATOR_TRANSCRIPTION } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import { useBooleanFlagValue } from '@rsos/utils/openFeature';
import { ActionBarItem } from '../ActionBarItem';

const ArchiveViewActionBarItem = () => {
  const isArchiveViewEnabled = useBooleanFlagValue('archive_view', false);
  const hasCommunicatorTranscriptionCapability = useHasCapability(
    COMMUNICATOR_TRANSCRIPTION,
  );

  const handleArchiveViewClick = () => {
    window.open('/archive_view', '_blank');
  };

  const shouldRender =
    isArchiveViewEnabled &&
    hasCommunicatorTranscriptionCapability?.hasCapability;

  return (
    <ActionBarItem
      iconWidth="18px"
      onClick={handleArchiveViewClick}
      shouldRender={shouldRender}
      tooltipText="View Call Archive"
      iconDataName="archive-view-action-bar-item-icon"
    >
      <EPData />
    </ActionBarItem>
  );
};

export default ArchiveViewActionBarItem;
